import React from 'react';
import { IconButton } from '@lsq/nextgen/v2/button';
import { ReactComponent as Add } from '../../../../assets/svgIcons/lsq_add.svg';
import { globalConstantValues } from '../../../../constants/globalConstant';
import LsqActionMenu from '../../../../components/LsqActionMenu';

/**
 * Shared cell wrapper for dashboards/homepages in Teams table
 * Handles layout, container, and add button consistently across mobile/web
 *
 * @param {Object} props
 * @param {React.Component} props.Container - TeamsContainer component
 * @param {Array} props.items - Array of item IDs
 * @param {Object} props.itemsById - Items mapped by ID
 * @param {string} props.teamId - Team ID
 * @param {Function} props.setDialog - Dialog state setter
 * @param {Function} props.setPreviewPanel - Preview panel setter (mobile only)
 * @param {boolean} props.showAddButton - Whether to show add button
 * @param {Object} props.addButtonConfig - Add button configuration
 */
export const DashboardsCellWrapper = ({
  Container,
  items,
  itemsById,
  teamId,
  setDialog,
  setPreviewPanel,
  showAddButton = true,
  addButtonConfig
}) => {
  const validItems = items.filter((itemId) => itemsById[itemId] !== undefined);

  const shouldShowAddButton =
    showAddButton && validItems.length < globalConstantValues.MAX_NUMBER_OF_TEAM_DASHBOARD;

  return (
    <div className="flex gap-1">
      {validItems.length > 0 ? (
        <Container
          dragAndDrop={true}
          isScrollable={true}
          homepages={items}
          homepagesById={itemsById}
          teamId={teamId}
          setPreviewPanel={setPreviewPanel}
          setDialog={setDialog}
        />
      ) : null}
      {shouldShowAddButton && (
        <>
          {addButtonConfig?.menuItems ? (
            // Web: Add button with dropdown menu
            <LsqActionMenu
              customContentClass="w-15rem"
              actions={addButtonConfig.menuItems.map((item) => ({
                label: item.label,
                value: item.label
              }))}
              onSelect={(action) => {
                const mockEvent = { stopPropagation: () => {} };
                addButtonConfig.onItemClick?.(mockEvent, action.value);
              }}>
              <IconButton
                size="xs"
                variant="secondary-gray"
                icon={<Add />}
                onClick={(e) => e.stopPropagation()}
                data-testid={addButtonConfig.dataTestId || 'add-button'}
              />
            </LsqActionMenu>
          ) : (
            // Mobile: Simple add button
            <IconButton
              size="xs"
              variant="secondary-gray"
              icon={<Add />}
              onClick={addButtonConfig?.onClick}
              data-testid={addButtonConfig?.dataTestId || 'add-button'}
            />
          )}
        </>
      )}
    </div>
  );
};
